import React from 'react'

const SvgMicrophoneOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 6a4 4 0 118 0v5a4 4 0 01-8 0V6zm6 0v5a2 2 0 11-4 0V6a2 2 0 114 0z'
    />
    <path d='M19.707 10.293A1 1 0 0018 11c0 3.308-2.691 6-6 6s-6-2.692-6-6a1 1 0 10-2 0c0 4.071 3.061 7.435 7 7.93V20H9a1 1 0 000 2h6a1 1 0 000-2h-2v-1.07c3.939-.495 7-3.859 7-7.93a1 1 0 00-.293-.707z' />
  </svg>
)

export default SvgMicrophoneOutline
